import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS.js";
import { buildCQLFilter } from "../../services/MapCore/MapCQLFilterService";
import authService from "../../services/AuthService";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import { create } from "ol/transform";
import { WMSLegend } from "../legends/WMSLegend";

const createAOILayer = (defaultLayer, onLeftClick, map, aoi_uuid) => {
  const layerObj = Object.assign({}, defaultLayer);
  const legend_wms = process.env.REACT_APP_GEOSERVER_URL_WMS;
  const base_url = process.env.REACT_APP_GEOSERVER_URL;
  const cql_filter = buildCQLFilter([
    { key: "uuid", values: [aoi_uuid], operation: "AND" },
  ]);
  const capa_wms_aoi = process.env.REACT_APP_GEOSERVER_LAYER_AOI;
  layerObj.id = "layer-aoi";
  layerObj.opacity = 1;
  layerObj.map = map;
  // layerObj.name = "Delimitación";
  layerObj.name = { es: "Delimitación", en: "Delimitation", pt: "Delimitação" };
  layerObj.zIndex = 41;
  layerObj.style = {
    legend_title: { es: "Delimitación", en: "Delimitation", pt: "Delimitação" },
  };
  // layerObj.legend = new WMSLegend({
  //   geoserver_layer_id: undefined,
  //   style: {
  //     legend_title: {
  //       es: "Delimitación",
  //       en: "Delimitation",
  //       pt: "Delimitação",
  //     },
  //   },
  // });

  // console.log("Procesando CQL de AOI - ", aoi_uuid, "uuid='" + aoi_uuid + "'");
  // layerObj.layer = new TileLayer({
  //   id: capa_wms_aoi,
  //   source: new TileWMS({
  //     url: base_url + legend_wms,
  //     params: {
  //       LAYERS: capa_wms_aoi,
  //       FORMAT: "image/png",
  //       //STYLES: "fill_color",
  //       TILED: false,
  //       SRS: "EPSG:4326", // Usar CRS para la versión 1.3.0 del WMS
  //       WIDTH: 768,
  //       HEIGHT: 600,
  //       VERSION: "1.3.0",
  //       CQL_FILTER: cql_filter,
  //     },
  //     //cql_filter:cql_filter,
  //     projection: "EPSG:4326",
  //     serverType: "geoserver",
  //     tileLoadFunction: (tile, src) => {
  //       const token = authService.getToken();
  //       fetch(src, {
  //         headers: {
  //           Authorization: `${token}`,
  //         },
  //       })
  //         .then((response) => response.blob())
  //         .then((blob) => {
  //           const objectURL = URL.createObjectURL(blob);
  //           tile.getImage().src = objectURL;
  //         })
  //         .catch((error) => console.error("Error cargando tile:", error));
  //     },
  //   }),
  // });
  layerObj.layer = new ImageLayer({
    id: capa_wms_aoi.id,
    source: new ImageWMS({
      url: base_url + legend_wms,
      params: {
        LAYERS: capa_wms_aoi,
        FORMAT: "image/png",
        // Es importante no incluir el parámetro TILED o asegurarlo en false
        SRS: "EPSG:4326",
        VERSION: "1.3.0",
        CQL_FILTER: cql_filter,
        WIDTH: 1000,
        HEIGHT: 1000,
      },
      projection: "EPSG:4326",
      serverType: "geoserver",
      imageLoadFunction: (image, src) => {
        const token = authService.getToken();
        fetch(src, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => response.blob())
          .then((blob) => {
            const objectURL = URL.createObjectURL(blob);
            image.getImage().src = objectURL;
          })
          .catch((error) => console.error("Error cargando imagen:", error));
      },
    }),
  });
  layerObj.onClickGetInfo = onLeftClick;
  layerObj.description = {
    es: '<div class="tooltip" id="delimitacion"><p><strong>Definición:<br/></strong> Un AOI (Area of Interest) es una región geográfica definida dentro de un conjunto de datos espaciales que se selecciona para su análisis o monitoreo.</p><p><strong>Uso:<br/></strong> Permite filtrar y enfocar análisis en una zona específica, facilitando la consulta de datos dentro de un área geográfica definida.</p></div>',
    en: '<div class="tooltip" id="delimitation"><p><strong>Definition:<br/></strong> An AOI (Area of Interest) is a geographical region defined within a set of spatial data that is selected for analysis or monitoring.</p><p><strong>Use:<br/></strong> It allows filtering and focusing analysis on a specific area, facilitating data queries within a defined geographic area.</p></div>',
    pt: '<div class="tooltip" id="delimitation"><p><strong>Definição:<br/></strong> Uma AOI (Área de Interesse) é uma região geográfica definida dentro de um conjunto de dados espaciais que é selecionada para análise ou monitoramento.</p><p><strong>Uso:<br/></strong> Permite filtrar e concentrar a análise em uma área específica, facilitando consultas de dados dentro de uma área geográfica delimitada.</p></div>',
  };
  layerObj.getLayerTools = () => [];

  return layerObj;
};

export { createAOILayer };
